export default "__VITE_ASSET__3ca5f8b3__"